// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-baa927d8]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.empty-state[data-v-baa927d8] {\n  text-align: center;\n  padding: 50px;\n  color: #909399;\n}\n.app-container[data-v-baa927d8] {\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
